import { t } from '@/core/localization';
export const getTableBodyEmptyErrorMessage = (error) => {
    if (!error)
        return t('unknown.error.label');
    // Status 401 Unauthorized
    if ('status' in error && error.status === 401)
        return `${t('access.denied.label')}:\n ${t('user.does.not.have.enough.access.rights').toLocaleLowerCase()}`;
    return `${t('error.label')}: ${JSON.stringify(error, null, 2)}`;
};
